module.exports = __webpack_public_path__ + "img/redbull-logo.99c8646d.png";